module.exports = __webpack_public_path__ + "static/media/blog-img4.2407a0fc.jpg";